import type { FilterForm, FilterOperator } from '../../utils/filterSettings';
import { Icon } from '../Icon';
import { SelectContent, SelectItem, SelectRoot, SelectTrigger, SelectValue } from '../Select';
import { Text } from '../Text';
import { getFilterPosition } from './utils';

export type AdvancedFilterOperatorSelectorProps = {
  form: FilterForm;
  operatorPath: string;
};

export function AdvancedFilterOperatorSelector({ form, operatorPath }: AdvancedFilterOperatorSelectorProps) {
  const groupPosition = getFilterPosition(operatorPath);
  const label = groupPosition ? `Combine filters in filter group ${groupPosition} with` : 'Combine filters with';

  return (
    <form.Field name={operatorPath}>
      {(field: any) => (
        <SelectRoot
          name={operatorPath}
          value={field.state.value as FilterOperator}
          onValueChange={(val) => {
            field.handleChange(val as FilterOperator);
          }}
        >
          <SelectTrigger className="h-6 w-16 rounded-sm" aria-label={label}>
            <SelectValue>
              <Text className="text-xs capitalize">{field.state.value as FilterOperator}</Text>
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="and">
              <Text className="text-xs">And</Text>
            </SelectItem>
            <SelectItem value="or">
              <Text className="text-xs">Or</Text>
            </SelectItem>
          </SelectContent>
        </SelectRoot>
      )}
    </form.Field>
  );
}

export type AdvancedFilterOperatorTextProps = {
  form: FilterForm;
  operatorPath: string;
};

export function AdvancedFilterOperatorText({ form, operatorPath }: AdvancedFilterOperatorTextProps) {
  return (
    <form.Field name={operatorPath}>
      {(field: any) => {
        const value = (field.state.value as FilterOperator | undefined) ?? 'and';
        return (
          <div className="box-border w-16 flex gap-1 items-center justify-start pl-2.5 py-0">
            <Icon icon="cornerBottomLeft" size={18} className="text-grey-30" />
            <Text className="text-xs capitalize">{value}</Text>
          </div>
        );
      }}
    </form.Field>
  );
}
